import React from 'react';

import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { useDropZone } from 'clean/hooks/useDropZone';
import Upload from 'components/Icons/Upload';

import './DropZone.scoped.scss';

interface Props {
  onChange: (fileList: FileList) => void;
  accept?: string[];
}

const DropZone: React.FC<Props> = ({ accept = [], onChange }) => {
  const { dragging, valid, props } = useDropZone({ accept, onChange });
  const { t } = useTranslation();

  const handleFileUpload = e => {
    onChange(e.target.files);
  };

  return (
    <label {...props} className={classNames({ 'file-drop-zone': true, dragging, invalid: !valid })}>
      <div className="content">
        <input
          multiple
          type="file"
          accept={accept.length > 0 ? accept.join(', ') : undefined}
          onChange={handleFileUpload}
        />
        <div className="icon">
          <Upload />
        </div>
        <span>
          {t('common:FileUploadDropZone.start')}
          <span className="browse">{t('common:FileUploadDropZone.end')}</span>
        </span>
      </div>
    </label>
  );
};

export default DropZone;
